import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { CheckinForm, SubmitButton } from "../Checkin/checkin.styles";

import {
  LoginFormContainer,
  LoginInputLabel,
  LoginTextInput,
  LoginInputWrapper,
} from "../login-guest/login-guest.styles";
import { UserContext } from "../../contexts/user.context";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";

const defaultFormFields = {
  email: "",
  password: "",
};

const GuestLoginForm = () => {
  const [params] = useSearchParams();
  const { t } = useTranslation();
  const [formFields, setFormFields] = useState(defaultFormFields);
  const { email, password } = formFields;

  const { signInUser } = useContext(UserContext);

  const resetFormFields = () => {
    setFormFields(defaultFormFields);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    const requestMail = `${email}@bnbvienna.com`;
    try {
      await signInUser(requestMail, password);
    } catch (error) {
      alert(`Fehler beim Anmelden: ${error}`)
    }
    
    resetFormFields();
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormFields({ ...formFields, [name]: value });
  };

  useEffect(() => {
    const brnr = new URLSearchParams(params).get("brnr");
    const pw = new URLSearchParams(params).get("pw");
    console.log(brnr, pw)
    if (!brnr || !pw) {
      return;
    } else {
      console.log(brnr, pw)
      const loginDirectly = async () => {
        await signInUser(`${brnr}@bnbvienna.com`, pw);
      };
      loginDirectly();
    }
  }, []);

  return (
    <CheckinForm onSubmit={handleSubmit}>
      <LoginFormContainer>
        <LoginInputWrapper>
          <LoginInputLabel htmlFor="email">{t("booking_nr")}</LoginInputLabel>
          <LoginTextInput
            type="text"
            name="email"
            onChange={handleChange}
            value={email}
          ></LoginTextInput>
        </LoginInputWrapper>
        <LoginInputWrapper>
          <LoginInputLabel htmlFor="password">{t("password")}</LoginInputLabel>
          <LoginTextInput
            type="password"
            name="password"
            onChange={handleChange}
            value={password}
          ></LoginTextInput>
        </LoginInputWrapper>
      </LoginFormContainer>
      {/* <button type="submit">Submit</button> */}
      <SubmitButton type="submit" style={{ marginTop: "100px" }}>
        {t("start_checkin")}
      </SubmitButton>
    </CheckinForm>
  );
};

export default GuestLoginForm;
